import React from "react";
import ControlButton from "ControlButton";
import { useFullscreen } from "../hooks/useFullscreen";

const FullscreenButton = () => {
  const { enabled: fullscreenEnabled, toggle: toggleFullscreen } =
    useFullscreen();

  if (!fullscreenEnabled) {
    return null;
  }

  return (
    <ControlButton
      ariaLabel="Toggle Fullscreen"
      border={false}
      classNameModifiers={["fullscreen", "icon"]}
      key="fullscreen-button"
      onClick={toggleFullscreen}
    >
      <i className="icon-Fullscreen2" />
    </ControlButton>
  );
};

export default React.memo(FullscreenButton);
